import { useMemo } from 'react';

export default function Stars({ count = 50 }) {
  const stars = useMemo(() =>
    Array.from({ length: count }, (_, i) => ({
      id:    i,
      top:   Math.random() * 100,
      left:  Math.random() * 100,
      size:  Math.random() * 2 + 0.5,
      delay: Math.random() * 5,
      dur:   2 + Math.random() * 3,
    })),
  [count]);

  return (
    <>
      {stars.map(s => (
        <div
          key={s.id}
          className="star"
          style={{
            top:     `${s.top}%`,
            left:    `${s.left}%`,
            width:   s.size,
            height:  s.size,
            '--delay': `${s.delay}s`,
            '--dur':   `${s.dur}s`,
            zIndex: 0,
          }}
        />
      ))}
    </>
  );
}
